let lastScrollY = 0;

window.addEventListener('scroll', () => {
  // Check if the page has been scrolled
  if (window.scrollY > 0) {
      $('.js-site-header').addClass('is-sticky');
  } else {
      $('.js-site-header').removeClass('is-sticky');
  }


  // Get the current scroll position
  // const currentScrollY = window.scrollY;
  
  // if (currentScrollY < lastScrollY) {
  //     console.log("Scrolling down");
  //     $('.js-site-header').addClass('scrolling-up');
  // } else {
  //     $('.js-site-header').removeClass('scrolling-up');
  // }
  
  // // Update the last scroll position
  // lastScrollY = currentScrollY;
});
